import { Body, Button, Dialog, FormGroup, ISelectOption, Select } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { createToast } from '../../../../../../FlashToaster';

export function CloseJobDialog({ fetchData, job, handleClose, isOpen }) {
  const [selectedCloseOption, setSelectedCloseOption] = React.useState<string>();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSelect = (selectedItem: ISelectOption) => {
    setSelectedCloseOption(selectedItem.value);
  };

  const closeOptions = [
    { value: 'Budgetary Constraints', label: 'Budgetary Constraints' },
    { value: 'Candidate Non-Responsiveness', label: 'Candidate Non-Responsiveness' },
    { value: 'Candidate No-Show in Interviews/Assessments', label: 'Candidate No-Show in Interviews/Assessments' },
    { value: 'Candidate Withdrawn', label: 'Candidate Withdrawn' },
    { value: 'Change in Strategy', label: 'Change in Strategy' },
    { value: 'Incorrect Pledge Submission by Organisation', label: 'Incorrect Pledge Submission by Organisation' },
    { value: 'Lack of Candidates to Review', label: 'Lack of Candidates to Review' },
    { value: 'Lack of Organisational Engagement', label: 'Lack of Organisational Engagement' },
    { value: 'Lack of Ring-Fencing', label: 'Lack of Ring-Fencing' },
    { value: 'Poor Candidate Quality', label: 'Poor Candidate Quality' },
    { value: 'Reason Unknown', label: 'Reason Unknown' },
    { value: 'Unaligned Recruitment Timeline', label: 'Unaligned Recruitment Timeline' },
    { value: 'Visa Sponsorship Issues', label: 'Visa Sponsorship Issues' },
    { value: 'Non-Responsive', label: 'Non-Responsive' },
    { value: 'Downsizing', label: 'Downsizing' },
    { value: 'Over Hired in Other Job Slates', label: 'Over Hired in Other Job Slates' },
  ];

  const selectedOption = closeOptions.find((option) => option.value === selectedCloseOption);

  const handleSubmit = () => {
    setIsSubmitting(true);
    const closeKey = 'close-job';
    createToast({ type: 'success', key: closeKey, isLoading: true, text: 'Closing job' });
    job.closeJob = true;
    job.closeReason = selectedCloseOption;
    job.save().then((success: boolean) => {
      if (success) {
        createToast({ type: 'success', key: closeKey, text: 'Successfully closed job' });
        fetchData();
        setIsSubmitting(false);
      } else {
        createToast({ type: 'error', key: closeKey, text: 'Unable to close job' });
        setIsSubmitting(false);
      }
    });
  };

  return (
    <Dialog title="Change workstream" isOpen={isOpen} onClose={handleClose}>
      <Body className="mar-b-1">Please select a reason for closing this internship</Body>
      <FormGroup label="Close reason">
        <Select
          onItemSelect={handleSelect}
          items={closeOptions}
          fill={true}
          buttonProps={{ large: true }}
          activeItem={selectedOption}
        />
      </FormGroup>
      <Button
        fill={true}
        text="Update"
        large={true}
        disabled={!selectedCloseOption}
        onClick={handleSubmit}
        loading={isSubmitting}
      />
    </Dialog>
  );
}
